$(function () {
  $('.cash-register-select').select2();
  $('.pickup-point-select').select2(fetchDataSelect2());
});

function fetchDataSelect2() {
  return {
    ajax: {
      url: $('.branch-depot-form').data('fetchPickupPointUrl'),
    dataType: 'json',
      delay: 250,
      data: function (params) {
        return {
          'branchDepotForm-queryString': params.term,
        };
    },
    processResults: function (data) {
      return {
        results: data.items,
      };
    },
    cache: true
  },
    minimumInputLength: 1,
      placeholder: 'Search',
    allowClear: true
  }
}
